import { useState, useEffect } from 'react'
import { formatCountdown } from '@/shared/lib/formatCountdown'
import { TransferWindowState, type GameweekStatus } from '../types'
import styles from './GameweekBanner.module.css'

type GameweekBannerProps = {
  gwStatus: GameweekStatus
}

export function GameweekBanner({ gwStatus }: GameweekBannerProps) {
  const [countdown, setCountdown] = useState<string | null>(null)

  useEffect(() => {
    if (!gwStatus.windowChangesAt) return
    setCountdown(formatCountdown(gwStatus.windowChangesAt))
    const id = setInterval(() => {
      setCountdown(formatCountdown(gwStatus.windowChangesAt!))
    }, 30_000)
    return () => clearInterval(id)
  }, [gwStatus.windowChangesAt])

  const { currentGameweek, windowState, windowChangesAt } = gwStatus
  const isOpen = windowState === TransferWindowState.Open

  if (currentGameweek === null && isOpen) {
    return (
      <div className={styles.banner} data-state="pre">
        <p className={styles.gwLabel}>AGUARDANDO INÍCIO</p>
        <p className={styles.preText}>Competição ainda não começou</p>
      </div>
    )
  }

  // Window closed but GW1 hasn't officially started — 60 min before first match
  const gwLabel = currentGameweek ?? 1

  return (
    <div className={styles.banner} data-state={isOpen ? 'open' : 'closed'}>
      {/* Row 1 — gameweek label */}
      <p className={styles.gwLabel}>RODADA {gwLabel}</p>

      {/* Row 2 — window state + countdown */}
      <div className={styles.statusRow}>
        <div className={styles.statePill}>
          <span className={styles.dot} />
          <span className={styles.stateText}>
            {isOpen ? 'Janela aberta' : 'Janela fechada'}
          </span>
        </div>

        {windowChangesAt && countdown && (
          <>
            <span className={styles.divider} />
            <div className={styles.countdown}>
              <span className={styles.countdownLabel}>
                {isOpen ? 'Fecha em' : 'Abre em'}
              </span>
              <span className={styles.countdownValue}>{countdown}</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
